import request from '@/utils/request'

export function login(username, password) {
  return request({
    url: '/auth/local',
    method: 'post',
    data: {
      identifier: username,
      password: password
    }
  })
}

export function loginStaff(username, password) {
  return request({
    url: '/msma/users/staff/login',
    method: 'post',
    data: {
      username: username,
      password: password
    }
  })
}

export function getInfo() {
  return request({
    url: '/users/me',
    method: 'get'
  })
}

export function getService() {
  return request({
    url: '/services/personal/' + process.env.SERVICE_NAME,
    method: 'get'
  })
}

export function joinService(data) {
  return request({
    url: '/services/join/' + process.env.SERVICE_NAME,
    method: 'post',
    data
  })
}

export function uploadPfp(data) {
  return request({
    url: '/services/uploadPfp/' + process.env.SERVICE_NAME,
    method: 'post',
    headers: { 'content-type': 'multipart/form-data' },
    data
  })
}

export function changeUserData(data) {
  return request({
    url: '/services/modify/' + process.env.SERVICE_NAME,
    method: 'post',
    data
  })
}

export function forgotPassword(data) {
  return request({
    url: '/auth/forgot-password',
    method: 'post',
    data
  })
}

export function resetPassword(data) {
  return request({
    url: '/auth/reset-password',
    method: 'post',
    data
  })
}

export function changePassword(id, data) {
  return request({
    url: `/users/${id}/change_password`,
    method: 'put',
    data
  })
}

export function logout() {
  return request({
    url: '/auth/logout',
    method: 'get'
  })
}


// WEBPACK FOOTER //
// ./src/api/login.js